/* src/app/private/components/user/user-profile/user-profile.component.scss */
label {
  margin-bottom: 5px;
}
.bordered-card {
  border: 1px solid var(--secondry-light-gray);
  border-radius: 10px;
}
.no-shadow-select {
  box-shadow: var(--p-select-shadow) !important;
}
.no-shadow-input {
  box-shadow: var(--p-inputtext-shadow) !important;
}
/*# sourceMappingURL=user-profile.component.css.map */
